module.exports = __webpack_public_path__ + "static/ropeHome.1f21df26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ropeHome.png
// module id = 119
// module chunks = 21571696733600 35783957827783 278999228825771